import Head from "next/head";
import { FunctionComponent, useEffect, useState } from "react";

import { Button, Form } from "@/components";
import { useChain } from "@/hooks";
import { currency, fetch, percentage } from "@/utils";

const Index: FunctionComponent = () => {
  const { chain } = useChain();
  const [currentInterestRate, setCurrentInterestRate] = useState<
    number | undefined
  >(undefined);
  const [maxDeposit, setMaxDeposit] = useState<number | undefined>(undefined);
  const [totalDeposited, setTotalDeposited] = useState<number | undefined>(
    undefined
  );

  useEffect(() => {
    (async () => {
      const [
        totalDepositedAllTime,
        currentInterestRate,
        availableDepositUsdValue,
      ] = await Promise.all([
        fetch<bigint>("treasuryPool", "totalDepositedAllTime")(chain),
        fetch<bigint>("treasuryPool", "currentInterestRate")(chain),
        fetch<bigint>("treasuryPool", "getAvailableDepositUsdValue")(chain),
      ]);

      if (totalDepositedAllTime) {
        setTotalDeposited(Number(totalDepositedAllTime) / 10 ** 18);
      }
      if (currentInterestRate) {
        setCurrentInterestRate(Number(currentInterestRate) / 10 ** 18);
      }
      if (availableDepositUsdValue) {
        setMaxDeposit(Number(availableDepositUsdValue) / 10 ** 18);
      }
    })();
  }, [chain]);

  return (
    <>
      <Head>
        <title>AIDeFi</title>
      </Head>
      <section>
        <ol>
          <li>Deposit Crypto</li>
          <li>System Automates BankX</li>
          <li>Withdraw Anytime</li>
        </ol>
        <table>
          <tbody>
            <tr>
              <th>Current Interest Rate</th>
              <td>{percentage(currentInterestRate)}</td>
            </tr>
            <tr>
              <th>Total All Time Deposited</th>
              <td>{currency(totalDeposited)}</td>
            </tr>
            <tr>
              <th>Deposit Capacity</th>
              <td>{currency(maxDeposit)}</td>
            </tr>
          </tbody>
        </table>
        <p>
          AI DeFi finds opportunities in the{" "}
          <a href="https://bankx.io/">BankX</a> system.
        </p>
        <p>
          Principal and interest is paid in the XSD Stablecoin from{" "}
          <a href="https://bankx.io/">BankX</a>.
        </p>
        <Button href="https://bankx.io/" wide>
          Learn More About <b>BankX</b>
        </Button>
        <p>
          By using AI DeFi, you agree to these{" "}
          <a href="https://bankx.io/terms">TERMS</a>.
        </p>
      </section>
      <Form
        currentlyDeposited={totalDeposited}
        currentInterestRate={currentInterestRate}
        maxDeposit={maxDeposit}
      />
    </>
  );
};

export default Index;
